// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".main-header-btns{display:flex;justify-content:space-between;padding:0 15px}.f-render-code{background:#2d2d2d;color:#ccc;font-family:Fira code,Fira Mono,Consolas,Menlo,Courier,monospace;font-size:14px;line-height:1.5;padding:5px;height:350px;margin-top:20px;min-height:350px}.f-render-code .prism-editor__textarea:focus{outline:none}", ""]);
// Exports
module.exports = exports;
